// API client for the Monday weekly digest email preferences.
import { api } from './api';

export const digestApi = {
  getDigestPrefs: () => api.get('/v2/ai/weekly-digest/prefs').then(r => r.data),
  // POST replaces the whole prefs subdocument, so always send the full object.
  setDigestPrefs: (body) => api.post('/v2/ai/weekly-digest/prefs', body).then(r => r.data),
};
